import { sinEaseInOut, slurp, easeInOut, clamp } from "./easing";

export default class Triangle {

	constructor(size, fill, period, changeTime) {
        this.size = size
        this.fill = fill
        this.period = period
        this.changeTime = changeTime

        // state
        this.animAmt = 0;
	}

    /**
     * @param {CanvasRenderingContext2D} context 
     */
	render(context, animAmt) {
        // Make it so it goes from 0 to 1 and then 1 to 0 (to simplify animation things)
        let localAmt = (animAmt / this.period) % 1;
        localAmt = 2 * localAmt;
        if (localAmt > 1) {
            localAmt = 2 - localAmt;
        }

        // now we're going to 'stretch' this around 0.5
        localAmt -= 0.5;
        localAmt *= 6 * this.period;
        localAmt += 0.5;
        localAmt = clamp(localAmt, 0, 1)

        this.drawTriangle(context, easeInOut(localAmt, 2));
    }
    
    /**
     * 
     * @param {Number} amt 0 -> triangle; 0.5 -> hex; 1 -> other triangle
     */
    drawTriangle(context, triangleAmt) {
        context.beginPath();
        for (let i = 0; i < 6; i ++) {
            let angleAmt = i / 6;
            let angle = 2 * Math.PI * angleAmt - 0.5 * Math.PI;

            let changeAmt = sinEaseInOut(triangleAmt + ((i % 2 == 0) ? 0 : 1));
            let radius = slurp(this.size, this.size / 2, changeAmt);
            let x = radius * Math.cos(angle);
            let y = radius * Math.sin(angle);
            if (i == 0) {
                context.moveTo(x, y);
            }
            else {
                context.lineTo(x, y);
            }
        }
        context.closePath();
        context.fillStyle = this.fill;
        context.fill();
    }

}



// WEBPACK FOOTER //
// ./js/triangle.js